import { createUseStyles } from 'react-jss'

import { colors } from '#base/js/variables.style'

export const style = {
  emphasis: {
    color: 'var(--theme-brand-accent)',
    fontWeight: 'bold'
  }
}

export const useStyles = createUseStyles(style)
